export interface IFormulario {
  nombre?: string;
}

export class Formulario implements IFormulario {
  constructor(public nombre?: string) {}
}
